import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { submitQuiz } from "../lib/api";
import { toast } from "sonner";
import { QUIZ_QUESTIONS } from "../components/quiz/quizData";
import { QuizProgress } from "../components/quiz/QuizProgress";
import { QuizQuestion } from "../components/quiz/QuizQuestion";
import { QuizResult } from "../components/quiz/QuizResult";

export default function FitQuiz() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const navigate = useNavigate();

  const totalSteps = QUIZ_QUESTIONS.length;
  const current = QUIZ_QUESTIONS[step];

  const _submit = async (final) => {
    setLoading(true);
    try {
      const res = await submitQuiz(final);
      setResult(res);
    } catch (e) {
      toast.error("Something didn't sit right. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onChoose = (optionId) => {
    const next = { ...answers, [current.key]: optionId };
    setAnswers(next);
    if (step < totalSteps - 1) {
      setStep(step + 1);
    } else {
      _submit(next);
    }
  };

  const restart = () => {
    setStep(0);
    setAnswers({});
    setResult(null);
  };

  return (
    <div className="bg-[#f0e9e1] min-h-[80vh]" data-testid="fit-quiz-page">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 lg:col-span-8 fade-up">
            <div className="micro-label text-[#1a1814]/60 mb-4">The Atelier · Fit Counsel</div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#1a1814] leading-[0.95]">
              Find your <em className="italic">tall</em> fit.
            </h1>
            <p className="text-[#1a1814]/75 leading-relaxed mt-6 max-w-xl">
              Five quiet questions. We'll draw a three-piece capsule from the studio, drafted to your height and palette.
            </p>
          </div>
        </div>

        <QuizProgress step={step} totalSteps={totalSteps} complete={!!result} />

        {!result ? (
          <QuizQuestion
            step={step}
            question={current}
            currentAnswer={answers[current.key]}
            loading={loading}
            onChoose={onChoose}
            onBack={() => setStep(step - 1)}
          />
        ) : (
          <QuizResult
            result={result}
            onRestart={restart}
            onShopAll={() => navigate("/shop")}
          />
        )}
      </div>
    </div>
  );
}
